var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box-list"},[_c('table',[_c('ToiletBoxListHeader'),_c('tbody',_vm._l((_vm.boxes),function(box){return _c('ToiletBoxListItem',{key:box.id,attrs:{"box":box,"gateway":_vm.gateway}})}),1)],1),(!_vm.boxes || _vm.boxes.length === 0)?_c('div',{staticClass:"empty-message"},[_vm._v("登録してください")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }